import { useCallback, useState } from "react";
import UpcomingActionResponseResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionResponseResource";

export enum EActionCardModal {
	CREATE_ACTION = "CREATE_ACTION",
	EDIT_ACTION = "EDIT_ACTION",
	DELETE_ACTION = "DELETE_ACTION",
}

export const useActionCardModal = () => {
	const [openedModal, setOpenedModal] = useState<EActionCardModal | null>(null);
	const [selectedAction, setSelectedAction] = useState<UpcomingActionResponseResource | null>(null);

	const isModalOpen = useCallback((modal: EActionCardModal) => openedModal === modal, [openedModal]);

	const onCloseModal = useCallback(() => {
		setOpenedModal(null);
		setSelectedAction(null);
	}, []);

	const onOpenCreateModal = useCallback(() => {
		setOpenedModal(EActionCardModal.CREATE_ACTION);
	}, [setOpenedModal]);

	const onOpenEditModal = useCallback(
		(action: UpcomingActionResponseResource) => {
			setOpenedModal(EActionCardModal.EDIT_ACTION);
			setSelectedAction(action);
		},
		[setOpenedModal],
	);

	const onOpenDeleteModal = useCallback(
		(action: UpcomingActionResponseResource) => {
			setOpenedModal(EActionCardModal.DELETE_ACTION);
			setSelectedAction(action);
		},
		[setOpenedModal],
	);

	return { selectedAction, isModalOpen, onCloseModal, onOpenCreateModal, onOpenEditModal, onOpenDeleteModal };
};
